module.exports = __webpack_public_path__ + "img/start-hearing.fd84fdcc.svg";